import type { Component } from 'vue';
import CenterPopup from './CenterPopup.vue';

export default new Map<string, Component>([
  ['CenterPopup', CenterPopup],
]);

